/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetDeliveryConditionsResponseJson } from './get-delivery-conditions-response-json';
import { GetDeliveryConditionsResult } from '../results/get-delivery-conditions-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { DeliveryConditionDto } from '../models/delivery-condition-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetDeliveryConditionsResponse extends ResponseWithErrorGeneric<GetDeliveryConditionsResponseJson, GetDeliveryConditionsResult> implements IResponseWithErrorGeneric<GetDeliveryConditionsResult> {
  public deliveryConditions: DeliveryConditionDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetDeliveryConditionsResponse>) {
    super(response, GetDeliveryConditionsResult.Error);
    if (this.result !== GetDeliveryConditionsResult.Success) {
      return;
    }

    this.deliveryConditions = this.body.deliveryConditions ? this.body.deliveryConditions : [];
  }
  //</custom-body>
}
